import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Sesión iniciada");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "No se pudo iniciar sesión"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050806] flex items-center justify-center px-5" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/assets/logo.jpg" alt="365 Cellular Energy" className="w-20 h-20 rounded-full object-cover mx-auto glow-emerald mb-4" />
          <h1 className="font-display text-2xl font-bold tracking-tight">Panel de administración</h1>
          <p className="text-sm text-gray-500 mt-1">365 Cellular Energy</p>
        </div>
        <form onSubmit={submit} className="rounded-2xl border border-emerald-500/20 bg-[#0D130F] p-6 space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="email" className="text-gray-300">Correo</Label>
            <div className="relative mt-1.5">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="pl-9 bg-[#050806] border-emerald-500/20 focus-visible:ring-emerald-500" placeholder="admin@365cellularenergy.com" />
            </div>
          </div>
          <div>
            <Label htmlFor="password" className="text-gray-300">Contraseña</Label>
            <div className="relative mt-1.5">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="pl-9 bg-[#050806] border-emerald-500/20 focus-visible:ring-emerald-500" placeholder="••••••••" />
            </div>
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-emerald-500 hover:bg-emerald-400 disabled:opacity-50 text-black font-semibold py-2.5 rounded-full transition-colors duration-200">
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
        <Link to="/" className="flex items-center justify-center gap-1.5 text-xs text-gray-500 hover:text-emerald-400 mt-6 transition-colors duration-200" data-testid="back-to-site-link">
          <ArrowLeft className="w-3 h-3" /> Volver a la página
        </Link>
      </motion.div>
    </div>
  );
}
